export default __webpack_public_path__ + "static/media/craon27.39d8328f.jpg";